const STORAGE_KEY = "clinica.leads.seenIds";
const MAX_SEEN_IDS = 200;

/** IDs presentes em `currentIds` que ainda não estão em `seenIds`. */
export function pickNewlyArrived(currentIds: string[], seenIds: ReadonlySet<string>): string[] {
  return currentIds.filter((id) => !seenIds.has(id));
}

export function loadSeenLeadIds(): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? new Set(parsed.filter((id): id is string => typeof id === "string")) : new Set();
  } catch {
    return new Set();
  }
}

/** Persiste os ids vistos, mantendo só os `MAX_SEEN_IDS` mais recentes (`ids` já vem em ordem de chegada). */
export function saveSeenLeadIds(ids: string[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(-MAX_SEEN_IDS)));
  } catch {
    // localStorage indisponível (modo privado etc.) — notificação continua funcionando
    // dentro da sessão atual, só perde a baseline entre reloads.
  }
}
